/**
 * Form
 * Utility actions for redux-form
 *
 * @module actions/Form
 */

import { change, untouch } from 'redux-form';

/**
 * Clears the field from the named redux-form
 *
 * @param {string} formName - the form name
 * @param {string} field - the form field
 * @returns {Function} redux-thunk that clears then removed the touched flag.
 */
export function clearFieldFromForm(formName, field) {
  return dispatch => {
    dispatch(change(formName, field, ''));
    dispatch(untouch(formName, field));
  };
}

/**
 * Changes the value for a redux-form
 *
 * @param {string} formName - the form name
 * @param {string} field - the form field
 * @param {any} value - the value to set the form
 * @returns {object} redux-form action for change checkbox
 */
export function changeFormFieldValue(formName, field, value) {
  return change(formName, field, value);
}
